import { render, staticRenderFns } from "./BootBread.vue?vue&type=template&id=268ef9ee"
import script from "./BootBread.vue?vue&type=script&lang=js"
export * from "./BootBread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports